import { isPayrollFeatureEnabled } from "@/business/product-access";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { ST_ADJUSTMENTS_ACCESS, type StAdjustmentsAccess } from "./types";

export const getStAdjustmentsAccess = ({
  productAccess,
  serviceTitanEnabled,
  isAiScript,
  hasFullWorkbookAccess,
}: {
  productAccess: StAdjustmentsAccess;
  serviceTitanEnabled: boolean;
  isAiScript: boolean;
  hasFullWorkbookAccess: boolean;
}): StAdjustmentsAccess => {
  if (!isAiScript || !hasFullWorkbookAccess) {
    return ST_ADJUSTMENTS_ACCESS.hidden;
  }

  if (productAccess === ST_ADJUSTMENTS_ACCESS.enabled && !serviceTitanEnabled) {
    return ST_ADJUSTMENTS_ACCESS.hidden;
  }

  return productAccess;
};

// Preserve the existing read-only preview when a valid saved selection is off.
export const useStAdjustmentsProductAccess = () => {
  const { settings, isLoading, hasValidSettings } = useBusinessProducts();
  const access = !hasValidSettings
    ? ST_ADJUSTMENTS_ACCESS.hidden
    : isPayrollFeatureEnabled(settings, "pushpay")
      ? ST_ADJUSTMENTS_ACCESS.enabled
      : ST_ADJUSTMENTS_ACCESS.preview;
  return { access, isLoading };
};
